<template>
  <div>
    <div class="app-title">
      <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section v-menu-permission="'list'" class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div id="collapseOne" aria-labelledby="headingOne" class="collapse show"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter ref="emListFilter" :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                           :entity="modelName"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesMstMaterialDrawingResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" aria-labelledby="headingTwo" class="collapse show"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table ref="emTable"
                        detailInlineButtonType="showAttachmentEntity"
                        :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                        :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                        :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                        :entity="modelName" :inlineActionsDisabled="prop_inline!=='1'" exportDisabled
                        @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"
                        @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow">
                <template #left-header>
                  <b-button-group>
                    <batch-upload-attachment-with-store
                        :doQuery="doQuery"
                        :modelName="modelName"
                        :voName=$_emCustomVuexMixin_vo
                        attachmentFieldName="mmdDrawingFileIds"
                        title="上传工艺图"
                    />
                    <b-button
                        :disabled="notSelected"
                        size="sm"
                        variant="outline-primary"
                        @click="downloadEngineeringDrawing()">下载SAP工程图
                    </b-button>
                    <b-button
                        :disabled="notSelected"
                        size="sm"
                        variant="outline-primary"
                        @click="updateEngineeringDrawing()">更新SAP工程图
                    </b-button>
                    <b-button
                        :disabled="notSelected"
                        size="sm"
                        type="export"
                        variant="outline-primary"
                        @click="batchDownloadToLocal('mmdDrawingFileIds')">批量存储到本地
                    </b-button>
                    <b-button
                        :disabled="actionDisabled('selectOne')"
                        size="sm"
                        type="save"
                        variant="outline-primary"
                        @click="openSelectMaterialDrawingDialog()">筛选生产显示图纸
                    </b-button>
                  </b-button-group>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    <!-- 筛选生产显示图纸的对话框 -->
    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="selectPrdUsageDrawingDialog" title="筛选生产显示图纸"
               width="60%"
               @close='closeSelectMaterialDrawing'>
      <el-table ref="materialDrawingTable" :data="currentMaterialDrawing" max-height="285px" style="width:100%"
                @selection-change="changeSelectedDrawing">
        <el-table-column type="selection" width="30"></el-table-column>
        <el-table-column label="物料编码" prop="mmdMaterialCode"></el-table-column>
        <el-table-column label="图纸文件名" prop="mmdDrawingName"></el-table-column>
        <el-table-column label="图纸版本" prop="mmdDrawingVersion"></el-table-column>
        <el-table-column label="图纸描述" prop="mmdDrawingDescription"></el-table-column>
      </el-table>
        <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="addDrawingDialog"
                 title="选择生产相关图纸"
                 width="60%" @close='closeSelectMaterialDrawingChild'>
        <el-row>
          <el-col :span="12">
            <el-form :inline=true :model="filterForm" label-position="left">
              <el-form-item label="物料号">
                <el-input v-model="filterForm.filterString"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-button-group>
              <el-button icon="el-icon-search" type="primary" @click="findMaterialDrawing">搜索</el-button>
              <el-button icon="el-icon-delete" type="danger" @click="resetFilterForm">重置</el-button>
            </el-button-group>
          </el-col>
        </el-row>
        <!-- 根据物料号搜索出的，未给生产显示的图纸文件 -->
        <el-table ref="optionalMaterialDrawingTable" :data="optionalMaterialDrawing" max-height="285px"
                  style="width:100%"
                  @selection-change="handleMaterialDrawingChange">
          <el-table-column type="selection" width="30"></el-table-column>
          <el-table-column label="物料编码" prop="mmdMaterialCode"></el-table-column>
          <el-table-column label="图纸文件名" prop="mmdDrawingName"></el-table-column>
          <el-table-column label="图纸版本" prop="mmdDrawingVersion"></el-table-column>
          <el-table-column label="图纸描述" prop="mmdDrawingDescription"></el-table-column>
        </el-table>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="noMaterialDrawingSelect" @click="deleteMaterialDrawing()">删除</el-button>
        <el-button @click="addMaterialDrawing()">添加</el-button>
        <el-button @click="selectPrdUsageDrawingDialog = false">取 消</el-button>
        <el-button type="primary" @click="finishSelectMaterialDrawing()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// Author Liu Cui Cui
// Date 2023-07-06 16:22:17

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import BatchUploadAttachmentWithStore from "@/components/common/attachment/BatchUploadAttachmentWithStore";

export default {
  name: "sithMesMstMaterialDrawingListView",
  components: {BatchUploadAttachmentWithStore},
  mixins: [emCommonListMixin, emCommonApiMixin, commonViewsUtil, emCustomVuexMixin, emTableCheckedMixin],
  data() {
    return {
      saveAttachmentLoading: false,
      attachmentIds: '',
      // 显示筛选生产显示图纸对话框
      selectPrdUsageDrawingDialog: false,
      // 当前物料被生产展示用的图纸
      currentMaterialDrawing: [],
      // 选中准备删除的图纸
      selectedMaterialDrawing: [],
      // 打开选择图纸对话框
      addDrawingDialog: false,
      // 可选的图纸文件，即未选择的图纸
      optionalMaterialDrawing: [],
      // 新增的图纸文件
      addedMaterialDrawing: [],

      filterForm: {
        filterString: '',
        materialCode: '',
      },
    }
  },
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0"
    }
  },
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    },
    $_customVuexName() {
      return this.customVuexName;
    },


    // 判断删除按钮是否可选
    noMaterialDrawingSelect() {
      return this.selectedMaterialDrawing.length === 0;
    }
  },
  methods: {

    getDetailInlineButtonType(row) {
      if (row.mmdDrawingFiles) {
        return 'showAttachmentEntity';
      }
      return 'showEntity';
    },

    downloadEngineeringDrawing() {

    },

    updateEngineeringDrawing() {

    },

    batchDownloadToLocal(paramName, fileName) {
      let attachmentIds = this.checkedRows.filter(f => this.hasCode(f[paramName])).map(o => o[paramName]).join(",");
      this.downloadAllAttachment(attachmentIds, fileName);
    },
    doQuery() {
      this.$refs["emListFilter"].doQuery();
    }

  },
  mounted() {
    this.doQuery()
  }
};
</script>
